// extracted by mini-css-extract-plugin
module.exports = {"message":"uploading-msg_message___uTyF"};